import React, { Component } from 'react';
import * as Sentry from '@sentry/react';
import { FlexColumn, FlexRow } from '@make-software/cspr-design';
import { HeaderText } from '@block-explorer/ui';

type State = { error: any | null };

const FallbackComponent = ({ error, componentStack, resetError }) => (
  <FlexRow justify="center" style={{ height: '100vh', width: '100vw' }}>
    <FlexColumn justify="center" style={{ textAlign: 'center' }}>
      <HeaderText size={2}>
        It looks like we're having issues. Our team was notified, please refresh
        your browser to try again.
      </HeaderText>
    </FlexColumn>
  </FlexRow>
);

export default class AppErrorHandler extends Component<unknown, State> {
  render() {
    return (
      <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
        {this.props.children}
      </Sentry.ErrorBoundary>
    );
  }
}
